import React from 'react';
import { Avatar, ListItemAvatar, Stack, Typography } from '@mui/material';
import { FileMetadata } from '../../api/types/cms';

import { useTranslation } from '../../contexts/TranslationContext';
import { getReadableFileSizeString } from '../../utils/static-files';
import { useDateFormatter } from '../../utils/date';
import { useImageBuilder } from '../../utils/image';

type FileInfoProps = {
    file: FileMetadata;
    global?: boolean;
};

export default function FileInfo({ file, global = false }: FileInfoProps) {
    const { translate } = useTranslation();
    const { formatDate } = useDateFormatter();
    const { buildImageUrl } = useImageBuilder();

    const hasPreview = file.mime_type?.match(/^image\/.*$/) ?? false;

    return (
        <Stack
            spacing={2}
            direction="row"
            alignItems="center"
            sx={{ flex: 1, py: 2, width: '100%', flexWrap: 'wrap' }}>
            {hasPreview && (
                <ListItemAvatar
                    className="imageContainer"
                    sx={{ height: '100%' }}>
                    <Avatar
                        src={buildImageUrl(file, 300)}
                        sx={{ width: 300, height: '100%' }}
                        variant="rounded"
                    />
                </ListItemAvatar>
            )}
            <Stack spacing={0} sx={{ flexWrap: 'wrap' }}>
                {!global && (
                    <Typography variant="caption" component="p">
                        {`${translate('pages.cms.files.version')}: ${file.version}`}
                    </Typography>
                )}
                <Typography variant="subtitle1" component="p">
                    {file.original_name}
                </Typography>
                <Typography
                    variant="caption"
                    color="text.primary"
                    component="p">
                    {formatDate(file.created_at)}
                </Typography>
                <Typography
                    variant="caption"
                    color="text.secondary"
                    component="p">
                    {getReadableFileSizeString(file.size ?? 0)}
                </Typography>
            </Stack>
        </Stack>
    );
}
